// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"641":"f830c697","698":"266f69e5"}[chunkId] + ".js";
};